module.exports = __webpack_public_path__ + "static/media/download-doc.1efba0fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/images/download-doc.svg
// module id = 65
// module chunks = 0